import React, { useState } from 'react';
import './VisibleItemsList.css';

const VisibleItemsList = ({ visibleItems, isLoading, onItemClick, selectedItem }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [activeTab, setActiveTab] = useState('all');

  const doctors = visibleItems.filter(item => item.type === 'doctor');
  const mvzs = visibleItems.filter(item => item.type === 'mvz');

  const getDisplayItems = () => {
    switch (activeTab) {
      case 'doctors':
        return doctors;
      case 'mvz':
        return mvzs;
      default:
        return visibleItems;
    }
  };

  const displayItems = getDisplayItems();

  return (
    <div className={`visible-items-container ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="visible-items-header" onClick={() => setIsCollapsed(!isCollapsed)}>
        <h3>
          <span className="toggle-icon">{isCollapsed ? '▲' : '▼'}</span>
          Ärzte & MVZ im Kartenausschnitt
          <span className="item-count">({visibleItems.length})</span>
        </h3>
      </div>
      
      {!isCollapsed && (
        <>
          <div className="visible-items-tabs">
            <button 
              className={`tab-button ${activeTab === 'all' ? 'active' : ''}`}
              onClick={() => setActiveTab('all')}
            >
              Alle ({visibleItems.length})
            </button>
            <button 
              className={`tab-button ${activeTab === 'doctors' ? 'active' : ''}`}
              onClick={() => setActiveTab('doctors')}
            >
              <span className="dot doctor-dot"></span>
              Ärzte ({doctors.length})
            </button>
            <button 
              className={`tab-button ${activeTab === 'mvz' ? 'active' : ''}`}
              onClick={() => setActiveTab('mvz')}
            >
              <span className="dot mvz-dot"></span>
              MVZ ({mvzs.length})
            </button>
          </div>

          <div className="visible-items-list">
            {isLoading ? (
              <div className="loading-indicator">Lade...</div>
            ) : displayItems.length === 0 ? (
              <div className="no-items">
                Keine {activeTab === 'doctors' ? 'Ärzte' : activeTab === 'mvz' ? 'MVZ' : 'Einträge'} im aktuellen Kartenausschnitt
              </div>
            ) : (
              displayItems.map((item, index) => {
                const isSelected = selectedItem && 
                  selectedItem.lat === item.lat && 
                  selectedItem.lng === item.lng;
                
                return (
                <div 
                  key={`${item.type}-${index}`} 
                  className={`item-card ${item.type} ${isSelected ? 'selected' : ''}`}
                  onClick={() => onItemClick && onItemClick(item)}
                >
                  <div className="item-type-indicator">
                    <span className={`dot ${item.type}-dot`}></span>
                  </div>
                  <div className="item-content">
                    <div className="item-name">{item.name}</div>
                    {item.address && (
                      <div className="item-address">{item.address}</div>
                    )}
                    {item.specialty && (
                      <div className="item-specialty">{item.specialty}</div>
                    )}
                  </div>
                </div>
              );
              })
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default VisibleItemsList;
